import { render, staticRenderFns } from "./AuthVerification.html?vue&type=template&id=4d035c95&scoped=true&"
import script from "./AuthVerification.ts?vue&type=script&lang=ts&"
export * from "./AuthVerification.ts?vue&type=script&lang=ts&"
import style0 from "./AuthVerification.scss?vue&type=style&index=0&id=4d035c95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d035c95",
  null
  
)

export default component.exports